export const statusCardDefaults = {
  statusColor: 'red',
  title: 'Status Card',
  toolTipText: 'Needs Attention',
};
